import { memo } from "react";
import "./Chips.css";

const Andar_Bahar = {
    0: { color: "#8e0000", fontSize: "50px" },
    1: { color: "#006d32", fontSize: "50px" },
    2: { color: "#03567e", fontSize: "50px" },
    3: { color: "#b16c00", fontSize: "50px" },
    4: { color: "#00097a", fontSize: "50px" },
    5: { color: "#7a0036", fontSize: "50px" },
    6: { color: "#a83700", fontSize: "50px" },
    7: { color: "#280042", fontSize: "50px" },
    8: { color: "#8e0000", fontSize: "50px" },
    9: { color: "#8e0000", fontSize: "50px" },
    10: { color: "#00097a", fontSize: "50px" },
    11: { color: "#00097a", fontSize: "50px" },
    12: { color: "black", fontSize: "50px" },
};
const FunCard = {
    0: { color: "#8e0000", fontSize: "50px" },
    1: { color: "#03567e", fontSize: "50px" },
    2: { color: "#006d32", fontSize: "50px" },
    3: { color: "#b16c00", fontSize: "50px" },
    4: { color: "#00097a", fontSize: "50px" },
    5: { color: "#7a0036", fontSize: "50px" },
    6: { color: "#a83700", fontSize: "50px" },
    7: { color: "#280042", fontSize: "50px" },
    8: { color: "#03567e", fontSize: "50px" },
    9: { color: "#b16c00", fontSize: "50px" },
    10: { color: "#00097a", fontSize: "50px" },
    11: { color: "#00097a", fontSize: "50px" },
    12: { color: "black", fontSize: "50px" },
};

const DragonTiger = {
    1: { color: "black", fontSize: "50px" },
    10: { color: "brown", fontSize: "50px" },
    20: { color: "blue", fontSize: "50px" },
    25: { color: "green", fontSize: "50px" },
    50: { color: "#ff002d", fontSize: "50px" },
    75: { color: "#016501", fontSize: "50px" },
    100: { color: "orange", fontSize: "50px" },
    200: { color: "purple", fontSize: "50px" },
    250: { color: "red", fontSize: "50px" },
    500: { color: "#00b5ff", fontSize: "50px" },
    1000: { color: "#5300ff", fontSize: "50px" },
    5000: { color: "black", fontSize: "50px" },
    10000: { color: "black", fontSize: "50px" },
};
const PaiGow = {
    0: { color: "black", fontSize: "50px" },
    1: { color: "#8B4513", fontSize: "50px" },
    2: { color: "brown", fontSize: "50px" },
    3: { color: "blue", fontSize: "50px" },
    4: { color: "green", fontSize: "50px" },
    5: { color: "#ff002d", fontSize: "50px" },
    6: { color: "#00b3e0ff", fontSize: "50px" },
    7: { color: "orange", fontSize: "50px" },
    8: { color: "purple", fontSize: "50px" },
    9: { color: "red", fontSize: "50px" },
    10: { color: "#00b5ff", fontSize: "50px" },
    11: { color: "#5300ff", fontSize: "50px" },
    12: { color: "grey", fontSize: "50px" },
};


const BetPlacedChip = memo(({ betAmount, chipString = "", gameId = -1, chipWidth = 200, chipHeight = 200, minFontSize = 110 }) => {

    const parseBetAmount = (amount) => {
        if (typeof amount === "string") {
            amount = amount.toLowerCase();
            if (amount.endsWith("k")) {
                return parseFloat(amount.replace("k", "")) * 1000;
            }
            return Number(amount);
        }
        return Number(amount);
    };
    const convertBetValue = (chngAmt) => {
        // console.log(chngAmt)
        let newAmt = Number((chngAmt));
        if (newAmt >= 1000 && newAmt <= 999999) {
            newAmt = Number((newAmt / 1000)?.toFixed(2)) + "K";
        } else if (newAmt >= 1000000 && newAmt <= 999999999) {
            newAmt = Number((newAmt / 1000)?.toFixed(2)) + "M";
        } else if (newAmt > 999999999) {
            newAmt = Number((newAmt / 1000)?.toFixed(2)) + "B";
        }
        return newAmt;
    }
    const availableBets = chipString
        .split(",")
        .map(Number)
        .filter((val) => !isNaN(val))
        .sort((a, b) => a - b);
    const numericBetAmount = parseBetAmount(betAmount);
    let PaiGowAvailableBets = [...availableBets]
    const matchedPaiGowBet = PaiGowAvailableBets.length - 1 - PaiGowAvailableBets
        .reverse().findIndex((bet) => bet <= numericBetAmount);

    const matchedBet = availableBets
        .reverse()
        .find((bet) => bet <= numericBetAmount) || 1;

    let chipConfig = {};

    switch (gameId) {
        case 1:
            chipConfig = FunCard[matchedPaiGowBet] || FunCard[0];
            break;
        case 24:
            chipConfig = Andar_Bahar[matchedPaiGowBet] || Andar_Bahar[0];
            break;
        case 20:
            chipConfig = PaiGow[matchedPaiGowBet] || PaiGow[1];
            break;
        case 31:
            chipConfig = PaiGow[matchedPaiGowBet] || PaiGow[0];
            break;
        default:
            chipConfig = PaiGow[matchedPaiGowBet] || PaiGow[0];
            break;
    }
    // if(gameId===24){

    //     const chipConfig = Andar_Bahar[matchedBet] || Andar_Bahar[1];
    // }


    const isMobile = /Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    );
    const cx = 200;
    const cy = 200;
    return (
        <svg
            width={chipWidth}
            height={chipHeight}
            viewBox="0 0 400 400"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* Background */}
            <circle cx={cx} r="200" cy={cy} fill={"#fff"} />
            {/* <rect width="400" height="400" fill={"#ffffff00"} /> */}

            {/* Outer segmented ring */}
            <circle
                cx={cx}
                cy={cy}
                r="195"
                fill="none"
                stroke={chipConfig.color}
                strokeWidth="1"
            />

            {/* Middle segmented ring */}
            <circle
                cx={cx}
                cy={cy}
                r="175"
                fill="none"
                stroke={chipConfig.color}
                strokeWidth="50"
                strokeDasharray="65 118.1666"
            />

            {/* Inner solid ring */}
            <circle
                cx={cx}
                cy={cy}
                r="155"
                fill="none"
                stroke={chipConfig.color}
                strokeWidth="25"
            />

            {/* Center circle */}
            <circle
                cx={cx}
                cy={cy}
                r="125"
                fill={"#fff"}
                stroke={chipConfig.color}
                strokeWidth="5"
            />

            {/* Center Text */}
            <text
                x={cx}
                y={cy}
                textAnchor="middle"
                dominantBaseline="central"
                fill={"#000"}
                fontSize={String(betAmount).length >= 4 ? minFontSize : 130}
                fontWeight="bold"
            >
                {convertBetValue(betAmount)}
            </text>
        </svg>

        // <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
        //     viewBox="0 0 97.7 97.7" height="97.7" width="97.7">
        //     <g id="Layer_x0020_1">
        //         <circle class="st0" fill={chipConfig.color} fillRule="evenodd" clipRule="evenodd" cx="48.8" cy="48.8" r="48.8" />
        //         <circle class="st1" fill={"#FEFEFE"} fillRule="evenodd" clipRule="evenodd" cx="48.8" cy="48.8" r="33.1" />
        //         <path class="st2" fill="#FEFEFE" d="M48.8,9.8c10.8,0,20.4,4.4,27.6,11.4c7,7,11.4,16.9,11.4,27.6s-4.4,20.4-11.4,27.6c-7,7-16.9,11.4-27.6,11.4
        // s-20.4-4.4-27.6-11.4c-7-7-11.4-16.9-11.4-27.6s4.4-20.4,11.4-27.6C28.2,14.2,38.1,9.8,48.8,9.8z M75.1,22.6
        // c-6.7-6.7-15.9-10.8-26.2-10.8c-10.1,0-19.5,4.2-26.2,10.8c-6.7,6.7-10.8,15.9-10.8,26.2c0,10.1,4.2,19.5,10.8,26.2
        // c6.7,6.7,15.9,10.8,26.2,10.8c10.1,0,19.5-4.2,26.2-10.8c6.7-6.7,10.8-15.9,10.8-26.2C85.8,38.7,81.6,29.3,75.1,22.6z"/>
        //         <path class="st2" fill="#FEFEFE" d="M32.3,3c-8.7,3.1-16.1,8.6-21.8,15.8l4.1,3.1l0,0c5.1-6.6,11.7-11.2,19.5-14L32.3,3z M2.7,33.1
        // C0.9,38.2,0,43.4,0,48.8v0.3v0.3v0.3v0.3v0.3v0.3V51v0.3v0.3V52v0.3v0.3v0.3v0.3v0.3v0.3v0.3v0.3v0.3v0.3v0.3v0.3V56v0.3v0.3V57
        // v0.3v0.3v0.3v0.3v0.3v0.3v0.3v0.3v0.3v0.3v0.2L5,59v-0.2v-0.3v-0.3v-0.3v-0.3v-0.3V57v-0.3v-0.3V56v-0.3v-0.3v-0.3v-0.3v-0.3v-0.3
        // v-0.3v-0.3v-0.3v-0.3v-0.3v-0.3V52v-0.3v-0.3V51v-0.3v-0.3v-0.3v-0.3v-0.3v-0.3v-0.3v-0.3v-0.3v-0.3v-0.3c0-4.8,0.8-9.5,2.3-14
        // l-4.8-1.7L2.7,33.1z M7.6,75.1c4.8,7.6,12,13.9,20.1,17.8l2.2-4.7c-7.3-3.6-13.7-9.1-18.1-15.9l-4.4,2.8H7.6z M83.3,83.2
        // c1.4-1.4,2.7-3,3.9-4.5c4.4-5.8,7.5-12,9.1-19.2l-5-1.1c-1.9,8-5.8,15.3-11.5,21.1l3.7,3.6L83.3,83.2z M74.4,7.3
        // c-4.4-2.8-9.2-4.7-14-5.9C56.5,0.5,52.6,0,48.5,0v5.1c7.6,0,15.1,2,21.7,5.8c0.5,0.3,0.9,0.6,1.4,0.9l2.8-4.4V7.3z"/>
        //         <path class="st3" display="none" d="M52.7,57.6h-3.3V45.1c-1.2,1.1-2.7,2-4.2,2.5v-3c0.9-0.3,1.9-0.8,2.8-1.6c1.1-0.8,1.7-1.7,2-2.8h2.7v17.5V57.6
        // z"/>
        //         <path class="st2" fill="#FEFEFE" d="M45.7,97.6c9,0.7,18.3-1.4,26.3-5.6l-2.5-4.5c-7.2,3.8-15.4,5.7-23.6,5.1l-0.3,5.2L45.7,97.6z M97.2,41.5
        // c-0.3-2-0.8-3.9-1.3-5.8c-2-6.9-5.2-13.2-10.1-18.7L82,20.4c5.3,6.2,8.9,13.7,10.1,21.8l5.1-0.9L97.2,41.5z"/>

        //         <text
        //             x="50%"
        //             y="50%"
        //             textAnchor="middle"
        //             dominantBaseline="middle"
        //             fill="#000"
        //             fontWeight="bold"
        //             fontSize={
        //                 String(betAmount).length >= 6
        //                     ? 24
        //                     : String(betAmount).length === 5
        //                         ? 28
        //                         : String(betAmount).length === 4
        //                             ? 42
        //                             : 22
        //             }
        //         >
        //             {convertBetValue(betAmount)}
        //         </text>
        //     </g>
        // </svg>
    );
});

export default BetPlacedChip;
